<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    :return-value.sync="time"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px">
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="time"
        :label="itemAction.name"
        prepend-inner-icon="mdi-clock-time-four-outline"
        @click:clear="clearData()"
        v-bind="attrs"
        v-on="on"
        readonly
        outlined
        dense/>
    </template>
    <v-time-picker v-if="menu" v-model="time" full-width format="24hr" @change="save"></v-time-picker>
  </v-menu>
</template>
<script>
export default {
  props: ['itemAction', 'setterModel', 'onSuccess'],
  data: () => ({
    time: null,
    menu: false
  }),
  mounted () {
    this.seterModel(this.setterModel)
  },
  methods: {
    seterModel (val) {
      if (val) this.time = val
      else if (this.itemAction.default) this.setDefault()
    },
    setDefault () {
    },
    clearData () {
      this.time = null
      this.onSuccess({ id: this.itemAction.nameid, data: null })
    },
    save (time) {
      this.$refs.menu.save(time)
      if (time != null) this.onSuccess({ id: this.itemAction.nameid, data: time })
    }
  },
  watch: {
    setterModel (time) {
      this.time = time
    }
  }
}
</script>

<style>

</style>
